<div class="ui fluid input" style="padding-top: 10px">
  <input
    type="text"
    placeholder="{{ placeholder }}"
    #inputEl
    (input)="setFormattedValue(inputEl.value)"
    [disabled]="disabled"
    [ngClass]="ngClass"
  />
</div>
